import React, { useState } from 'react';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { isEmpty as _isEmpty } from 'lodash';
import '@style/Tab.scss';
import queryString from 'query-string';
import { useMobxStores } from '@stores/store';
import media from '@organisms/media/Media';

const MediaTab = ({ category, onClickTab, activeCtg, isShow, allShow }) => {
  const { i18n } = useTranslation();
  if (!category && !_isEmpty(category)) return;

  const allTabList = [
    {
      idx: 0,
      koCategory: '전체 보기',
      enCategory: 'Show All',
      jpCategory: '全体表示',
    },
    ...category,
  ];

  return (
    <div id="tab">
      <div>
        <div>
          <nav className={classnames('relative z-0 ')} aria-label="Tabs">
            {allTabList.map((row, index) => (
              <button
                key={`index-${index}`}
                aria-current="page"
                onClick={e => onClickTab(e, row.idx)}
                className={classnames(
                  'break-all inline-block  py-3 px-4 mb-2 mr-3 leading-[0] rounded-full bg-[#b185f3] text-white p-2 items-center justify-center',
                  {
                    'bg-[#8d4fea] ': activeCtg === row.idx,
                  },
                  {
                    'bg-[#b185f3]': !(activeCtg === row.idx),
                  },
                  {
                    hidden: index > 10 && isShow == false,
                  }
                )}
              >
                <span className=" text-[12px] xl:text-[18px] font-extrabold font-TmoneyRoundWind leading-[1.1]">
                  {
                    row[
                      `${i18n.language === 'kr' ? 'ko' : i18n.language}Category`
                    ]
                  }
                </span>
              </button>
            ))}

            {category.length > 10 && (
              <button
                className={`${
                  isShow ? 'hidden' : ''
                } inline-block  py-4 px-4 mb-2 mr-3 leading-[0] rounded-full bg-[#b185f3] text-white p-2 items-center justify-center
                `}
                onClick={e => allShow()}
              >
                ···
              </button>
            )}
          </nav>
        </div>
      </div>
    </div>
  );
};

export default observer(MediaTab);
